import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';

export const registrationDataRequiredGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const { dataGetter } = route.data;
  if (!dataGetter()) {
    return false;
  }
  return true;
};
